require('./bootstrap');
import organisms from './organisms/index';
import ready from './templates/shared/ready';
//require('./libs/x-editable/bootstrap4-editable/js/bootstrap-editable.min.js');

function onReady() {

    window.fu = window.fu || {};

    var $html = $("html");
    
    organisms();

    if ($.browser.msie) {
        $html.addClass('msie');
    }
    if ($.browser.msedge) {
        $html.addClass('msedge');
    }
    if ($.browser.iphone) {
        $html.addClass('iphone');
    }
    if ($.browser.ipad) {
        $html.addClass('ipad');
    }
    if ($.browser.mac && $.browser.safari) {
        $html.addClass('mac-safari');
    }
    if ($.browser.safari) {
        $html.addClass('safari');
    }
}

ready(onReady);